/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc
 */
import * as References from './NotificationsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#getNotifications
 */
export const GET_NOTIFICATIONS_QUERY_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NotificationsRpc_getNotifications';
export const GET_NOTIFICATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NOTIFICATIONS_QUERY_FIELD_NAME,
  args: ['offset', 'limit', 'portalInstanceType', 'notificationType', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getNotificationsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#markNotificationAsRead
 */
export const MARK_NOTIFICATION_AS_READ_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NotificationsRpc_markNotificationAsRead';
export const MARK_NOTIFICATION_AS_READ_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MARK_NOTIFICATION_AS_READ_MUTATION_FIELD_NAME,
  args: ['notificationId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.markNotificationAsReadRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#markAllNotificationsAsRead
 */
export const MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NotificationsRpc_markAllNotificationsAsRead';
export const MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: MARK_ALL_NOTIFICATIONS_AS_READ_MUTATION_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.markAllNotificationsAsReadRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc#deleteNotification
 */
export const DELETE_NOTIFICATION_MUTATION_FIELD_NAME = 'com_hubspot_portals_platform_app_rpc_NotificationsRpc_deleteNotification';
export const DELETE_NOTIFICATION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_NOTIFICATION_MUTATION_FIELD_NAME,
  args: ['notificationId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.deleteNotificationRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});